<template lang="pug">
div
  header#topnav
    .topbar-main
      .container-fluid
        // Logo container
        .logo
          // Text Logo
          a.logo(href="/v3/")
            span
              i.mdi.mdi-chart-bar-stacked.m-r-5
              span {{ $t('SiteTitle') }}
              span.d-none.d-md-inline {{ $t('SiteTitleSub') }}
        // End Logo container
        .menu-extras.topbar-custom
          ul.list-inline.float-right.mb-0
            li.list-inline-item.dropdown.notification-list.d-inline.d-lg-none
              a.nav-link.dropdown-toggle.nav-user(data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false")
                .text-lg
                  i.mdi.mdi-menu
              .dropdown-menu.dropdown-menu-right.profile-dropdown(aria-labelledby="Preview")
                router-link(to="/" class="dropdown-item notify-item")
                  strong
                    i.mdi.mdi-arrow-right-box
                    | {{ $t('NewReport') }}
                router-link(to="/history/" class="dropdown-item notify-item" v-if="hasHistory")
                  i.mdi.mdi-clock
                  | {{ $t('RecentReports') }}
                a.dropdown-item.nogify-item(v-bind:href="$t('ProductLink')")
                  i.mdi.mdi-open-in-new
                  | {{ $t('ProductName') }}

          ul.list-inline.float-right.mb-0
            TasksCount
        .clearfix
      // end container
    // end topbar-main
    .navbar-custom
      .container-fluid
        #navigation
          // Navigation Menu
          ul.navigation-menu
            li
              router-link(to="/")
                .text-lg
                  i.mdi.mdi-arrow-right-box.m-r-5
                  | {{ $t('NewReport') }}
            li(v-if="hasHistory")
              router-link(to="/history/")
                i.mdi.mdi-clock.m-r-5
                | {{ $t('RecentReports') }}
            li
              a(v-bind:href="$t('ProductLink')")
                i.mdi.mdi-open-in-new
                | {{ $t('ProductName') }}
 
          // End navigation menu
        // end #navigation
      // end container
    // end navbar-custom
  // End Navigation Bar

</template>

<i18n>
{
  "ja": {
    "SiteTitle": "LightFileシミュレータ",
    "SiteTitleSub": "・画像軽量化の可能性を無料レポート",
    "NewReport": "新しいレポートを作成",
    "RecentReports": "最近見たレポート",
    "ProductName": "LightFile",
    "ProductLink": "https://www.ideamans.com/lp1/lightfile-bot/"
  }
}</i18n>

<style>
.logo {
  text-transform: none !important;
  display: inline-block;
  white-space: nowrap;
}
.profile-dropdown {
  width: auto;
}
</style>

<script>
import TasksCount from '@/components/TasksCount'
import Lib from '@/lib'

export default {
  components: {
    TasksCount,
  },
  data() {
    return {
      history: [],
    }
  },
  created() {
    this.updateHistory()
    setInterval(() => this.updateHistory(), 30 * 1000)
  },
  methods: {
    updateHistory() {
      const history = new Lib.History(window.localStorage.getItem('history'))
      this.history = history.records
    },
  },
  computed: {
    hasHistory() {
      return this.history.length > 0
    },
  },
}
</script>
